import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useId,
  useGlobal,
} from "reactn";
import styled from "styled-components";
import optionsMenuData from "./optionsMenuData";
import forward from "assets/icons/forward.ico";
import back from "assets/icons/back.ico";
import observer from "assets/icons/observer.ico";
import god from "assets/god/ui/godtitle.gif";
import { OptionsMenu } from "components";
import starsBg from "assets/god/ui/stars.gif";
import glowBg from "assets/god/ui/glow.png";
import Observatory from "./Observatory.js";
import ViewObject from "./ViewObject.js";
import { Research, ResearchMenu } from "./Research.js";
import Intro from "./Intro.js";
import SpaceShuttle from "./SpaceShuttle.js";
import IntroSub from "./IntroSub.js";
import AllTokens from "./AllTokens.js";
import AllObjects from "./AllObjects.js";
import ViewToken from "./ViewToken.js";
import * as Tone from "tone";
import { objects } from "./utils/objects.js";
import { displayMetadata } from "./utils/displaymetadata.js";

const GodObserver = ({
  onHelp,
  onClose,
  id,
  injectedProps,
  onToggleComponent,
  standAlone,
  windowView,
}) => {
  const appId = useId().replaceAll(":", "");
  const backPages = useRef([]);
  const nextPages = useRef([]);
  const collectionId = "1";
  const [contract] = useGlobal("contract");
  const [account] = useGlobal("account");
  const [web3] = useGlobal("web3");
  const [token, setToken] = useState(null);
  const [allTokens, setAllTokens] = useState(null);
  const [newToken, setNewToken] = useState(null);
  const [myTokens, setMyTokens] = useState(null);
  const [userTokens, setUserTokens] = useState(null);
  const [tokenOwner, setTokenOwner] = useState(null);
  const [view, setView] = useState(standAlone ? windowView : "Intro");
  const selection = window.getSelection().anchorNode;
  const [catalog, setCatalog] = useState("All Tokens");
  const [object, setObject] = useState(null);
  const [allTokensByObj, setAllTokensByObj] = useState(null);
  const [dropOptions, setDropOptions] = useState({
    MilkyWayStyle: "0",
    MilkyWay: true,
    StarsLabels: false,
    Static: true,
    Shooting: true,
    Shining: true,
    Wandering: true,
    CardinalPoints: true,
    SolarSystem: true,
    SolarSystemLabels: true,
    Effects: true,
    Music: true,
    Realtime: true,
    Location: false,
    Date: false,
    Fullscreen: false,
  });
  const objpointer = document.querySelector(".objpointer" + appId);
  const main = document.getElementById("go_box");
  const mainTop = document.getElementById("go_top");
  const baseURI = "https://api.heaven.computer";

  const getUserTokens = useCallback(async (user) => {
      setUserTokens(null);
      let tokenIds = [];
      let balance = await contract["balanceOf(address)"](user).catch((e) => {
        setView("Error");
        return;
      });
      for (let i = 0; i < parseInt(balance); i++) {
        await contract["tokenOfOwnerByIndex(address,uint256)"](user, i).then(
          (id) => {
            if (id < 1000000) return;
            tokenIds.push(id.toString());
          }
        );
      }
      setUserTokens(tokenIds.sort());
    },
    [contract]
  );

  const getTokenOwner = useCallback(
    async (token) => {
      setTokenOwner(null);
      if (token) {
        let owner = await contract["ownerOf(uint256)"](token);
        const name = await web3.lookupAddress(owner);
        name ? setTokenOwner(name) : setTokenOwner(owner);
      }
    },
    [contract, web3]
  );

  useEffect(() => {
    if (standAlone) {
      optionsMenuData["Catalogue"][2].disable = true;
    }
    if (standAlone && windowView) {
      if (windowView === "Intro") {
        setView(windowView);
      } else if (
        (windowView === "All Tokens" ||
          windowView === "All Objects" ||
          windowView === "My Tokens") &&
        allTokens
      ) {
        setCatalog(windowView);
        setView(windowView);
      } else if (windowView.startsWith("catalogue?")) {
        const obj = objects.find(
          (e) =>
            e.label.replace(/\s/g, "").toLowerCase() ===
            windowView.substring(10).toLowerCase()
        );
        setObject(obj);
        setCatalog("Object");
        setView("Object");
      } else if (windowView.startsWith("observatory?")) {
        const obj = objects.find(
          (e) =>
            e.label.replace(/\s/g, "").toLowerCase() ===
            windowView.substring(12).toLowerCase()
        );
        setObject(obj);
        setCatalog("Object");
        setView("ObjObservatory");
      } else if (windowView.startsWith("token?") && allTokens) {
        getTokenOwner(windowView.substring(6));
        setToken(windowView.substring(6));
        setView("View Token");
      } else if (windowView.startsWith("user?") && allTokens) {
        getUserTokens(windowView.substring(5));
        setTokenOwner(windowView.substring(5));
        setView("User Tokens");
      } else {
        setView("Error");
      }
    }
  }, [standAlone, windowView, allTokens, getUserTokens, getTokenOwner]);

  function handleViewToken(token) {
    setToken(token);
    getTokenOwner(token);
    createViewList("View Token", view);
    if (standAlone) window.history.pushState("", "", "/token/" + token);
  }
  function handleViewUser(user) {
    getUserTokens(user);
    createViewList("User Tokens", view);
    if (standAlone) window.history.pushState("", "", "/user/" + user);
  }

  const getAllCollectionTokens = useCallback(async () => {
    setAllTokens(null);
    let tokens = [];
    await contract["viewAllCollectionTokens(uint256)"](collectionId).then(
      (r) => {
        for (let i = 0; i < r.length; i++) {
          tokens.push(r[i].toString());
        }
      }
    );
    setAllTokens(tokens);
  }, [contract]);

  const getMyTokens = useCallback(async () => {
    setMyTokens(null);
    let tokenIds = [];
    let balance = await contract["balanceOf(address)"](account);
    for (let i = 0; i < parseInt(balance); i++) {
      await contract["tokenOfOwnerByIndex(address,uint256)"](
        account,
        i
      ).then((id) => {
        if (id < 1000000) return;
        tokenIds.push(id.toString());
      });
    }
    setMyTokens(tokenIds.sort());
  }, [contract, account]);

  useEffect(() => {
    if (contract) getAllCollectionTokens();
  }, [contract, getAllCollectionTokens]);

  useEffect(() => {
    if (contract && account) getMyTokens();
  }, [contract, account, getMyTokens]);

  useEffect(() => {
    function fetchTokensByObj(obj) {
      setAllTokensByObj(null);
      let tokenIdArr = [];
      displayMetadata.forEach((item, i) => {
        if (item.celestialobjectname === obj.name)
          tokenIdArr.push(item.tokenId);
      });
      setAllTokensByObj(tokenIdArr);
    }
    if (object) fetchTokensByObj(object);
  }, [object, baseURI]);

  useEffect(() => {
    if (main && mainTop) {
      main.addEventListener("scroll", function (e) {
        if (main.scrollTop > main.offsetHeight / 4) {
          mainTop.style.opacity = "1";
          mainTop.classList.add("pointer");
        } else {
          mainTop.style.opacity = "0";
          mainTop.classList.remove("pointer");
        }
      });
    }
  }, [main, mainTop]);

  useEffect(() => {
    const onMouseLeave = () => {
      document.querySelector("#fairy_wrapper").style.display = "none";
      document.querySelector("#cursor_wrapper").style.display = "block";
    };
    const onMouseEnter = () => {
      document.querySelector("#cursor_wrapper").style.display = "none";
      document.querySelector("#fairy_wrapper").style.display = "block";
    };
    const onFullscreen = (e) => {
      const fullscreen = optionsMenuData.Observatory.find(
        (e) => e.text === "Fullscreen"
      );
      if (!document.fullscreenElement) {
        setDropOptions((d) => {
          return { ...d, Fullscreen: false };
        });
        fullscreen.check = false;
      }
    };
    const go_window = document.querySelector("#go_wrapper").parentElement.parentElement;
    go_window.addEventListener("mouseenter", onMouseEnter);
    go_window.addEventListener("mouseleave", onMouseLeave);
    document.addEventListener("fullscreenchange", onFullscreen);
    document.addEventListener("mozfullscreenchange", onFullscreen);
    document.addEventListener("webkitfullscreenchange", onFullscreen);
    document.addEventListener("msfullscreenchange", onFullscreen);
    const muteAll = () => {
      document.hidden
        ? (Tone.Destination.mute = true)
        : (Tone.Destination.mute = false);
    };
    document.addEventListener("visibilitychange", muteAll);
    return () => {
      onMouseLeave();
      backPages.current = [];
      nextPages.current = [];
      go_window.removeEventListener("mouseenter", onMouseEnter);
      go_window.removeEventListener("mouseleave", onMouseLeave);
      document.removeEventListener("visibilitychange", muteAll);
      document.removeEventListener("fullscreenchange", onFullscreen);
      document.removeEventListener("mozfullscreenchange", onFullscreen);
      document.removeEventListener("webkitfullscreenchange", onFullscreen);
      document.removeEventListener("msfullscreenchange", onFullscreen);
    };
  }, []);

  useEffect(() => {
    optionsMenuData.Catalogue.forEach((e) => {
      e.text === catalog ? (e.select = true) : (e.select = false);
    });
    optionsMenuData.Catalogue.find((e) => e.text === "Objects").items.forEach(
      (e, i) => {
        object && e.text === object.name && catalog === "Object"
          ? (e.select = true)
          : (e.select = false);
      }
    );
  }, [catalog, object, view]);

  useEffect(() => {
    const nextGod = document.getElementById("nextGod" + appId);
    const backGod = document.getElementById("backGod" + appId);
    if (nextPages.current.length > 0 && nextPages.current[0] !== view) {
      optionsMenuData["View"][3].disable = false;
      nextGod.classList.remove("disabled");
    } else {
      optionsMenuData["View"][3].disable = true;
      nextGod.classList.add("disabled");
    }
    if (
      backPages.current.length > 0 &&
      backPages.current[backPages.current.length - 1] !== view
    ) {
      optionsMenuData["View"][2].disable = false;
      backGod.classList.remove("disabled");
    } else {
      optionsMenuData["View"][2].disable = true;
      backGod.classList.add("disabled");
    }
    if ((nextPages.current.length || backPages.current.length) > 0) {
      optionsMenuData["Edit"][3].disable = false;
    } else {
      optionsMenuData["Edit"][3].disable = true;
    }
    if (
      view === "Intro" ||
      view === "Research" ||
      view === "ObjObservatory" ||
      view === "SpaceShuttle" ||
      view === "View Token" ||
      view === "Object"
    ) {
      if (selection) {
        optionsMenuData["Edit"][0].disable = true;
        optionsMenuData["Edit"][1].disable = false;
      } else {
        optionsMenuData["Edit"][0].disable = false;
        optionsMenuData["Edit"][1].disable = true;
      }
    } else {
      optionsMenuData["Edit"][0].disable = true;
      optionsMenuData["Edit"][1].disable = true;
    }
    const invert = optionsMenuData.Observatory.find((e) => e.text === "Invert");
    const fullscreen = optionsMenuData.Observatory.find(
      (e) => e.text === "Fullscreen"
    );
    const select_loc = optionsMenuData.Observatory.find(
      (e) => e.text === "Location"
    ).items.find((e) => e.text === "Select...");
    const realtime = optionsMenuData.Observatory.find(
      (e) => e.text === "Date"
    ).items.find((e) => e.text === "Realtime");
    const select_dat = optionsMenuData.Observatory.find(
      (e) => e.text === "Date"
    ).items.find((e) => e.text === "Select...");
    if (view === "Observatory" || view === "ObjObservatory") {
      fullscreen.disable = false;
      invert.disable = false;
      select_loc.disable = false;
      if (!realtime.check) select_dat.disable = false;
    } else {
      fullscreen.disable = true;
      invert.disable = true;
      select_loc.disable = true;
      select_dat.disable = true;
      fullscreen.check = false;
      invert.check = false;
    }
  }, [view, appId, selection]);

  useEffect(() => {
    if (injectedProps) {
      if (injectedProps === "documents") {
        setCatalog("My Tokens");
        setView("My Tokens");
      } else if (injectedProps === "alltokens") {
        setCatalog("All Tokens");
        setView("All Tokens");
      }
    }
  }, [injectedProps]);

  useEffect(() => {
    if (dropOptions.Realtime) {
      optionsMenuData.Observatory.find((e) => e.text === "Date").items.forEach(
        (item, i) => {
          if (
            item.text === "Time" ||
            item.text === "Speed" ||
            item.text === "Select..."
          )
            item.disable = true;
        }
      );
    } else {
      optionsMenuData.Observatory.find((e) => e.text === "Date").items.forEach(
        (item, i) => {
          if (
            item.text === "Time" ||
            item.text === "Speed" ||
            item.text === "Select..."
          )
            item.disable = false;
        }
      );
    }
  }, [dropOptions.Realtime]);

  const createViewList = useCallback(
    (curr, prev) => {
      if (curr === prev) return;
      if (selection) onSelectNone();
      backPages.current.push(prev);
      setView(curr);
    },
    [selection]
  );

  function onMintDone(mintedToken) {
    setNewToken(mintedToken);
    createViewList("SpaceShuttle", view);
  }
  function onMintWait() {
    setNewToken("wait");
  }

  function scrollToTop() {
    main.scrollTo({ top: 0, behavior: "smooth" });
    mainTop.classList.remove("pointer");
  }

  const onSelectNone = () => {
    window.getSelection().removeAllRanges();
  };
  const onRefresh = () => {
    if (selection) onSelectNone();
    backPages.current = [];
    nextPages.current = [];
    setObject(null);
    setCatalog("All Objects");
    setView("Intro");
  };
  const handleNavigation = (flow) => {
    if (flow === "back") {
      if (
        backPages.current.length > 0 &&
        backPages.current[backPages.current.length - 1] !== view
      ) {
        nextPages.current.unshift(view);
        if (standAlone)
          window.history.pushState(
            "",
            "",
            path(backPages.current[backPages.current.length - 1])
          );
        setView(backPages.current[backPages.current.length - 1]);
        backPages.current[0] === backPages.current[backPages.current.length - 1]
          ? (backPages.current = [])
          : backPages.current.pop();
      } else {
        return;
      }
    } else if (flow === "forward") {
      if (nextPages.current.length > 0 && nextPages.current[0] !== view) {
        backPages.current.push(view);
        if (standAlone)
          window.history.pushState("", "", path(nextPages.current[0]));
        setView(nextPages.current[0]);
        nextPages.current[0] === nextPages.current[nextPages.current.length - 1]
          ? (nextPages.current = [])
          : nextPages.current.shift();
      } else {
        return;
      }
    }
  };

  const path = (view) => {
    if (view === "Intro") {
      return "/";
    } else if (view === "User Tokens") {
      return "/catalogue/" + tokenOwner;
    } else if (view === "Object") {
      const obj =
        "/catalogue/" +
        object.label.replace(/\s+/g, "").replace(/,/g, "+").toLowerCase();
      return obj;
    } else if (view === "ObjObservatory") {
      const obj =
        "/observatory/" +
        object.label.replace(/\s+/g, "").replace(/,/g, "+").toLowerCase();
      return obj;
    } else if (view === "All Tokens") {
      return "/catalogue/alltokens";
    } else if (view === "My Tokens") {
      return "/catalogue/mytokens";
    } else if (view === "All Objects") {
      return "/catalogue/allobjects";
    } else if (view === "View Token") {
      return "/token/" + token;
    } else {
      return view ? "/" + view.replace(/\s+/g, "").toLowerCase() : "/";
    }
  };
  const boxName = (view) => {
    if (view === "Intro") {
      return "intro";
    } else if (view === "User Tokens") {
      return tokenOwner;
    } else if (view === "Object") {
      return object.name.toLowerCase();
    } else if (view === "ObjObservatory") {
      return "observatory";
    } else if (view === "View Token") {
      return "#" + (parseInt(token) - 1000000).toString();
    } else {
      return view ? view.toLowerCase() : "error";
    }
  };
  const onSelectAll = () => {
    const el = document.querySelector(".selectable");
    if (document.body.createTextRange) {
      let range = document.body.createTextRange();
      range.moveToElementText(el);
      range.select();
    } else if (window.getSelection) {
      let selection = window.getSelection();
      let range = document.createRange();
      range.selectNodeContents(el);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  useEffect(() => {
    if (objpointer) {
      objpointer.addEventListener("pointerdown", () => {
        let obj = objects.find(
          (e) => e.label.replace(/\s/g, "") === objpointer.id
        );
        setObject(obj);
        setCatalog("Object");
        createViewList("ObjObservatory", view);
        if (standAlone)
          window.history.pushState(
            "",
            "",
            "/observatory/" +
            obj.label.replace(/\s+/g, "").replace(/,/g, "+").toLowerCase()
          );
      });
    }
  }, [objpointer, createViewList, view, standAlone]);

  function handleViewObject(object) {
    setObject(object);
    setCatalog("Object");
    createViewList("Object", view);
    if (standAlone)
      window.history.pushState(
        "",
        "",
        "/catalogue/" +
        object.label.replace(/\s+/g, "").replace(/,/g, "+").toLowerCase()
      );
  }
  function handleViewObjObserv(object) {
    setObject(object);
    setCatalog("Object");
    createViewList("ObjObservatory", view);
    if (standAlone)
      window.history.pushState(
        "",
        "",
        "/observatory/" +
        object.label.replace(/\s+/g, "").replace(/,/g, "+").toLowerCase()
      );
  }

  function onClickOptionItem(item) {
    if (item.disable) return;
    switch (item.text) {
      case "Object Catalogue":
        const obj = objects[Math.floor(Math.random() * objects.length)];
        if (view === catalog) {
          handleViewObject(obj);
        } else {
          handleViewObjObserv(obj);
        }
        break;
      case "Token Catalogue":
        const tok = 1000000 + parseInt(Math.random() * allTokens.length);
        handleViewToken(tok);
        break;
      case "Intro":
        createViewList("Intro", view);
        if (standAlone) window.history.pushState("", "", "/");
        break;
      case "Back":
        handleNavigation("back");
        break;
      case "Forward":
        handleNavigation("forward");
        break;
      case "Refresh":
        onRefresh();
        break;
      case "Select All":
        onSelectAll();
        break;
      case "Select None":
        onSelectNone();
        break;
      case "Close":
        onClose();
        break;
      case "About...":
        standAlone ? onHelp("GO") : onToggleComponent("Help", "open", id, "GO");
        break;
      case "Help Center":
        standAlone ? onHelp("Home") : onToggleComponent("Help", "open", id);
        break;
      case "Invert":
        const skymap = document.querySelector("#skymap" + appId);
        const skymap_cnv = document.querySelector("#skymap" + appId + "_cnv");
        //const invert = optionsMenuData.Observatory.find((e) => e.text === "Map").items.find((e) => e.text === "Invert");
        const invert = optionsMenuData.Observatory.find(
          (e) => e.text === "Invert"
        );
        if (invert && skymap && skymap_cnv) {
          if (invert.check) {
            invert.check = false;
            skymap.classList.remove("map_inverted");
            skymap_cnv.classList.remove("cnv_inverted");
          } else {
            invert.check = true;
            skymap.classList.add("map_inverted");
            skymap_cnv.classList.add("cnv_inverted");
          }
        } else {
          return;
        }
        break;
      default:
        if (item.type === "item" || item.type === "menu") {
          if (item.text === "Select...") {
            setDropOptions({
              ...dropOptions,
              Select: item.code,
            });
            document.querySelector("#skymap_select_wrapper").style.display =
              "flex";
          } else if (item.code === "Calendar") {
            setDropOptions({
              ...dropOptions,
              ChangeTime: item.text.replace(/\s/g, ""),
            });
          } else if (item.code === "Speed") {
            setDropOptions({
              ...dropOptions,
              [item.text.replace(/\s/g, "")]: !dropOptions[
                item.text.replace(/\s/g, "")
              ],
            });
          } else if (item.text === "Labels") {
            setDropOptions({
              ...dropOptions,
              [item.code + "Labels"]: !dropOptions[item.code + "Labels"],
            });
            item.check = !item.check;
          } else {
            setDropOptions({
              ...dropOptions,
              [item.text.replace(/\s/g, "")]: !dropOptions[
                item.text.replace(/\s/g, "")
              ],
            });
            item.check = !item.check;
          }
        } else if (item.type === "option") {
          if (item.code === "MilkyWay") {
            optionsMenuData.Observatory.find((e) => e.text === "Milky Way")
              .items.find((e) => e.text === "Style")
              .items.forEach((e, i) => {
                if (e.text === item.text) {
                  setDropOptions({
                    ...dropOptions,
                    MilkyWayStyle: i.toString(),
                  });
                  item.select = true;
                } else {
                  e.select = false;
                }
              });
          } else if (item.code === "Projection") {
            optionsMenuData.Observatory.find(
              (e) => e.text === "Projection"
            ).items.forEach((e, i) => {
              if (e.text === item.text) {
                setDropOptions({
                  ...dropOptions,
                  Projection: item.text.toLowerCase(),
                });
                item.select = true;
              } else {
                e.select = false;
              }
            });
          } else if (item.code === "Catalogue") {
            optionsMenuData.Catalogue.forEach((e) => {
              if (e.text === item.text) {
                setCatalog(item.text);
                createViewList(item.text, view);
                if (standAlone)
                  window.history.pushState("", "", path(item.text));
              }
            });
          } else if (item.code === "Object") {
            optionsMenuData.Catalogue.find(
              (e) => e.text === "Objects"
            ).items.forEach((e, i) => {
              if (e.text === item.text) {
                const obj = objects.find((e) => e.name === item.text);
                if (view === catalog) {
                  handleViewObject(obj);
                } else {
                  handleViewObjObserv(obj);
                }
              }
            });
          }
        }
        break;
    }
  }

  return (
    <Div id="go_wrapper">
      <section className="window_toolbar">
        <OptionsMenu items={optionsMenuData} onClickItem={onClickOptionItem} />
      </section>
      <div className="divider"></div>
      <section className="address_bar">
        <div className="div_bar"></div>
        <div className="address_bar_title">
          A<u>d</u>dress
        </div>
        <div className="address_bar_content">
          <div className="address_bar_content_text">
            <img
              draggable={false}
              src={observer}
              alt="favicon"
              className="address_bar_content_img"
            />
            <span>https://god.observer{path(view)}</span>
            <div className="address_bar_buttons">
              <div className="address_bar_go">
                <div />
              </div>
              <div
                id={"backGod" + appId}
                title="back"
                className="address_bar_back"
                onClick={() => handleNavigation("back")}
              >
                <img draggable={false} alt="back" src={back} />
              </div>
              <div
                id={"nextGod" + appId}
                title="forward"
                className="address_bar_forward"
                onClick={() => handleNavigation("forward")}
              >
                <img draggable={false} alt="forward" src={forward} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="window_content" id="go_inner">
        <div className="window_content_inner go_scrollbar">
          <div id="go_title_wrapper" className={"go_title_wrapper" + appId}>
            <div id="go_title" className={"go_title" + appId}>
              <img draggable={false} src={god} alt="god.observer" />
              <span>on-chain astrotheology</span>
            </div>
            <div id="go_menu">
              <span
                onClick={() => {
                  createViewList("Intro", view);
                  if (standAlone) window.history.pushState("", "", "/");
                }}
                className="route_link crosshair"
              >
                intro
              </span>
              {"//"}
              <span
                onClick={() => {
                  createViewList("Observatory", view);
                  Tone.start();
                  if (standAlone)
                    window.history.pushState("", "", "/observatory");
                }}
                className="route_link crosshair"
              >
                observatory
              </span>
              {"//"}
              <span
                onClick={() => {
                  if (standAlone) {
                    if (catalog === "Object") {
                      let obj = object;
                      handleViewObject(obj);
                    } else if (catalog === "ObjObservatory") {
                      let obj = object;
                      handleViewObjObserv(obj);
                    } else {
                      createViewList(catalog, view);
                      if (standAlone)
                        window.history.pushState("", "", path(catalog));
                    }
                  } else {
                    createViewList(catalog, view);
                  }
                }}
                className="route_link crosshair"
              >
                catalogue
              </span>
              {"//"}
              <span
                onClick={() => {
                  createViewList("Research", view);
                  if (standAlone) window.history.pushState("", "", "/research");
                }}
                className="route_link crosshair"
              >
                research
              </span>
            </div>
          </div>

          <div id="center_wrap">
            <div id="upper_wrap">
              <div id="go_box_wrap">
                <div id="go_box" className="go_scrollbar no_corner">
                  <div className="center_title">
                    <div id="go_box_title">{boxName(view)}</div>
                    <div
                      id="go_top"
                      onClick={scrollToTop}
                    >
                      <span>top</span>
                      <span>△</span>
                    </div>
                  </div>
                  {view === "Error" && (<p style={{padding: "10px"}}>Not found.</p>)}
                  {view === "Intro" && (
                    <Intro
                      onToggleComponent={onToggleComponent}
                      id={id}
                      onMintDone={onMintDone}
                      onMintWait={onMintWait}
                      standAlone={standAlone}
                      createViewList={createViewList}
                    />
                  )}
                  {(view === "Observatory" || view === "ObjObservatory") && (
                    <Observatory
                      dropOptions={dropOptions}
                      object={object}
                      setObject={setObject}
                      objectView={view === "ObjObservatory"}
                      appId={appId}
                    />
                  )}
                  {view === "My Tokens" && (
                    <AllTokens
                      id={id}
                      allTokens={myTokens}
                      baseURI={baseURI}
                      handleViewToken={handleViewToken}
                      type="mine"
                    />
                  )}
                  {view === "All Tokens" && (
                    <AllTokens
                      id={id}
                      allTokens={allTokens}
                      baseURI={baseURI}
                      handleViewToken={handleViewToken}
                      type="all"
                    />
                  )}
                  {view === "User Tokens" && (
                    <AllTokens
                      id={id}
                      allTokens={userTokens}
                      baseURI={baseURI}
                      handleViewToken={handleViewToken}
                      type="user"
                    />
                  )}
                  {view === "Object" && (
                    <AllTokens
                      id={id}
                      allTokens={allTokensByObj}
                      baseURI={baseURI}
                      handleViewToken={handleViewToken}
                      type="object"
                    />
                  )}
                  {view === "All Objects" && (
                    <AllObjects
                      id={id} handleViewObject={handleViewObject} />
                  )}
                  {view === "Research" && (
                    <Research
                      id={id}
                      standAlone={standAlone}
                      createViewList={createViewList}
                      onToggleComponent={onToggleComponent}
                    />
                  )}
                  {view === "SpaceShuttle" && (
                    <SpaceShuttle newToken={newToken} baseURI={baseURI} />
                  )}
                  {view === "View Token" && (
                    <ViewToken
                      handleViewUser={handleViewUser}
                      handleViewObjObserv={handleViewObjObserv}
                      handleViewToken={handleViewToken}
                      baseURI={baseURI}
                      token={token}
                      allTokens={allTokens}
                      tokenOwner={tokenOwner}
                      onToggleComponent={onToggleComponent}
                      id={id}
                      standAlone={standAlone}
                    />
                  )}
                </div>
              </div>

              {(view === "Object" ||
                view === "ObjObservatory" ||
                view === "Research") && (
                  <div id="desc_box_wrap">
                    <div id="desc_box" className="go_scrollbar no_corner">
                      {view === "Research" && (
                        <>
                          <ResearchMenu />
                        </>
                      )}
                      {(view === "Object" || view === "ObjObservatory") && (
                        <>
                          <div className="side_title">
                            <div>{object.label}</div>
                          </div>
                          <ViewObject
                            object={object}
                            view={view}
                            createViewList={createViewList}
                          />
                        </>
                      )}
                    </div>
                  </div>
                )}
            </div>

            {view === "Intro" && <IntroSub />}
          </div>
        </div>
        <div id="ticker-wrap">
          <div id="ticker">
            <div className="ticker_item">mint re-opened!!!</div>
            <div className="ticker_item">God Observer</div>
            <div className="ticker_item">on-chain astrotheology</div>
            <div className="ticker_item">virtual planetarium</div>
            <div className="ticker_item">interactive stargazing</div>
            <div className="ticker_item">interstellar travel</div>
            <div className="ticker_item">glitch astral technoscope</div>
            <div className="ticker_item">crypto lunatic asylum</div>
            <div className="ticker_item">extraterrestrial sceance</div>
            <div className="ticker_item">quantic zodiac subversion</div>
            <div className="ticker_item">...and more!</div>
            <div className="ticker_item">mint re-opened!!!</div>
            <div className="ticker_item">God Observer</div>
            <div className="ticker_item">mint re-opened!!!</div>
            <div className="ticker_item">God Observer</div>
          </div>
        </div>
      </div>
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  height: 100%;
  background: var(--colorgrad3);
  scroll-behavior: smooth;
  #go_box_title {
    max-width: calc(100%);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  canvas,
  img:not(.address_bar_content_img) {
    image-rendering: -moz-crisp-edges;
    image-rendering: -webkit-crisp-edges;
    image-rendering: pixelated;
    image-rendering: crisp-edges;
  }
  .window_content {
    z-index: 0;
    background-image: url(${starsBg});
    background-position: top;
    background-repeat: repeat;
  }
  .window_content_inner {
    padding: 0 20px;
    height: calc(100% - 4px);
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 1;
    background: transparent url(${glowBg}) repeat top center;
    -moz-animation: move-twink-back 200s linear infinite;
    -ms-animation: move-twink-back 200s linear infinite;
    -o-animation: move-twink-back 200s linear infinite;
    -webkit-animation: move-twink-back 200s linear infinite;
    animation: move-twink-back 200s linear infinite;
  }
  #go_inner p:not(.pointer), #go_menu, #go_inner h1, #go_inner h2, #go_inner h3, #go_inner h4, #go_inner li, #go_inner ul, #go_inner b, .selectable span:not(.pointer), .go_table {
    color: white;
  }
  @keyframes move-twink-back {
    from {
      background-position: 0 0;
    }

    to {
      background-position: -10000px 5000px;
    }
  }

  @-webkit-keyframes move-twink-back {
    from {
      background-position: 0 0;
    }

    to {
      background-position: -10000px 5000px;
    }
  }

  @-moz-keyframes move-twink-back {
    from {
      background-position: 0 0;
    }

    to {
      background-position: -10000px 5000px;
    }
  }

  @-ms-keyframes move-twink-back {
    from {
      background-position: 0 0;
    }

    to {
      background-position: -10000px 5000px;
    }
  }
  h1 {
    text-align: center;
    font-size: 18px;
    line-height: 22px;
    font-weight: 800;
  }
  h2 {
    padding: 0 0 10px 0;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    font-weight: 800;
  }
  b {
    font-weight: 700;
  }
  h3 {
    display: flex;
    align-items: center;
    margin: 5px 0 10px 0;
    line-height: 15px;
    font-size: 1.1em;
    font-weight: 800;
  }
  h4 {
    font-size: 1em;
    font-weight: 800;
  }
  .selectable {
    & *:not(img):not(.go_mint_btn):not(.see_all p) {
      user-select: text;
    }
  }
  .address_bar_content_text {
    user-select: text;
  }
  a,
  .go_links {
    text-decoration: underline dashed;
    text-underline-offset: 3px;
    color: white;
    line-height: 15px;
  }

  a:hover,
  .go_links:hover {
    text-decoration-color: white;
    color: #b19cd9;
  }
  #go_title_wrapper {
    z-index: 2;
    flex: 0 0 auto;
    display: block;
    padding: 15px 10px;
  }

  #go_title {
    z-index: 2;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: -10px;
    min-height: 30px;
  }

  #go_title span {
    text-align: center;
    font-family: mozart, monospace;
    color: #b19cd9;
    text-transform: lowercase;
    position: relative;
    top: -14px;
    font-size: 16px;
    letter-spacing: 4px;
    /* text-shadow: 2px 2px 0 #b19cd9;
    */
  }

  #go_title img {
    width: 100%;
    max-width: 420px;
    -webkit-filter: drop-shadow(1px 1px 0 rgba(226, 223, 247, 0.8))
      drop-shadow(-1px -1px 0 rgba(226, 223, 247, 0.8));
    filter: drop-shadow(1px 1px 0 rgba(226, 223, 247, 0.8))
      drop-shadow(-1px -1px 0 rgba(226, 223, 247, 0.8));
  }
  .buttons_row {
    .go_mint_btn {
      width: 32px;
      height: 25px;
    }
    .go_mint_btn + .go_mint_btn {
      margin-left: 10px;
    }
  }
  .go_input {
    border: 0;
    outline: 0;
    min-width: 46px;
    margin: 0 10px;
    input {
      background: transparent;
      height: 25px;
      color: white;
      border: 1px solid #b19cd9;
      display: flex;
      align-items: center;
      padding: 6px;
      outline: 0;
      white-space: nowrap;
      letter-spacing: 2px;
      font-size: 11px;
      width: 100%;
      text-decoration: none;
    }
    input.disabled {
      color: var(--colorgrad5);
      border: 1px dotted var(--colorgrad5);
      outline: none;
    }
    input:active {
      border: 1px dashed #b19cd9;
      outline: 0;
    }
  }

  /* CENTER */
  #upper_wrap {
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    min-height: 100px;
    padding-top: 20px;
  }
  #center_wrap {
    position: relative;
    top: -30px;
    flex-direction: column;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    min-height: 100px;
    margin-bottom: 10px;
  }
  #go_box_wrap,
  #desc_box_wrap {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    align-self: center;
    height: 100%;
    min-height: 100px;
    min-width: 100px;
  }
  #go_box {
    width: calc(100% - 10px);
    margin: 0px auto;
    align-self: flex-start;
  }
  #desc_box {
    width: 100%;
    align-self: flex-end;
    height: calc(100% - 20px);
  }
  #go_box_wrap {
    flex: 2 1 400px;
    max-height: 100%;
    padding: 15px 0px 15px 0px;
  }
  #desc_box_wrap {
    flex: 1;
    max-height: 100%;
    margin: 0 5px;
    padding: 15px 0px 15px 0px;
  }
  #go_box,
  #desc_box {
    letter-spacing: 1px;
    height: 100%;
    z-index: 2;
    resize: horizontal;
    border: 1px dashed #b19cd9;
    overflow: auto;
  }

  #go_bottom {
    font-family: mozart, monospace;
    display: flex;
    justify-content: center;
    flex-direction: row;
    z-index: 2;
    text-align: center;
    letter-spacing: 3px;
    position: relative;
    pointer-events: none;
    padding-top: 20px;
    width: 100%;
    img.blinkies + img.blinkies {
      margin-left: 2px;
    }
    div {
      max-width: 700px;
      align-self: center;
    }
    .no_border {
      margin-top: 6px;
    }
  }
  .go_mint_btn {
    background: transparent;
    color: #b19cd9;
    border: 1px solid #b19cd9;
    display: flex;
    align-items: center;
    padding: 6px;
    text-overflow: hidden;
    text-align: center;
  }
  .go_mint_btn.see_all {
    word-break: break-word;
    text-overflow: hidden;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    & p {
      clip-path: inset(-10px -10px -1px -10px);
    }
  }
  .go_mint_btn.disabled {
    color: var(--colorgrad5);
    border: 1px dashed var(--colorgrad5);
    outline: none;
  }
  .go_mint_btn:not(.disabled):active {
    outline: 1px dotted var(--colorgrad5);
    outline-offset: -5px;
    border: 1px dashed #b19cd9;
  }
  .center_title {
    width: inherit;
    flex: 1 1 auto;
  }
  .center_title,
  .side_title {
    font-family: mozart, monospace;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    letter-spacing: 3px;
    justify-content: space-between;
    align-self: center;
    z-index: 2;
    color: #b19cd9;
    position: absolute;
    margin-top: -14px;
  }

  #go_top {
    display: none;
    opacity: 0;
    transition: opacity 1s;
  }
  .center_title,
  .side_title {
    div span {
      transition: opacity 1s;
    }
    div:nth-child(2) {
      position: sticky;
      display: flex;
      right: -17px;
    }
    div span:nth-child(2) {
      font-family: Verdana, Helvetica, sans-serif;
      font-size: 13px;
    }
    div span:first-child {
      opacity: 0;
      margin-right: 4px;
    }
    div:hover {
      & span {
        opacity: 1;
      }
    }
  }

  /* MENU */

  #go_menu {
    font-family: mozart, monospace;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    align-self: center;
    z-index: 2;
    text-align: center;
    font-size: 14px;
    letter-spacing: 3px;
  }

  .route_link {
    padding: 2px 0 1px 3px;
    margin: 0 12px;
    color: white;
    text-transform: uppercase;
    text-decoration: none;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
  }

  .route_link:hover {
    border-top: 1px dashed #b19cd9;
    border-bottom: 1px dashed #b19cd9;
  }

  .no_border a {
    border: 0;
  }

  /* TICKER */
  @-webkit-keyframes ticker {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }
  }
  li {
    list-style-type: decimal;
  }
  @keyframes ticker {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }
  }

  #ticker-wrap {
    font-family: mozart, monospace;
    display: flex;
    z-index: 1;
    width: calc(100% - 200px);
    position: absolute;
    bottom: 1px;
    overflow: hidden;
    padding-left: 100%;
    clip-path: inset(-1px 4px -1px 1px);
  }

  #ticker {
    display: flex;
    white-space: nowrap;
    padding-right: 100%;
    box-sizing: content-box;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -webkit-animation-name: ticker;
    animation-name: ticker;
    -webkit-animation-duration: 100s;
    animation-duration: 100s;
  }

  #ticker-wrap .ticker_item {
    font-size: 13px;
    display: inline-block;
    padding: 0 40px;
    text-transform: uppercase;
    letter-spacing: 3px;
    color: #b19cd9;
  }

  /* STARRY BACKGROUND */
  @keyframes move-twink-back {
    from {
      background-position: 0 0;
    }

    to {
      background-position: -10000px 5000px;
    }
  }

  @-webkit-keyframes move-twink-back {
    from {
      background-position: 0 0;
    }

    to {
      background-position: -10000px 5000px;
    }
  }

  @-moz-keyframes move-twink-back {
    from {
      background-position: 0 0;
    }

    to {
      background-position: -10000px 5000px;
    }
  }

  @-ms-keyframes move-twink-back {
    from {
      background-position: 0 0;
    }

    to {
      background-position: -10000px 5000px;
    }
  }

  ::selection {
    background-color: hsla(201, 100%, 91%, 0.8);
    color: var(--black);
  }

  /* SCROLLBAR */
  .go_scrollbar::-webkit-scrollbar {
    width: 16px;
    height: 16px;
  }

  .go_scrollbar::-webkit-scrollbar-track {
    background: transparent;
  }

  .go_scrollbar::-webkit-scrollbar-thumb {
    border: 1px solid #b19cd9;
    background: transparent;
    box-shadow: none;
  }

  .go_scrollbar::-webkit-scrollbar-corner {
    background-color: transparent;
    box-shadow: none;
    background-repeat: no-repeat;
    background-position: right bottom;
    background-image: url("data:image/png;base64,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");
  }

  .no_corner::-webkit-resizer {
    border: none;
    box-shadow: none;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: right 1px bottom 1px;
    background-image: url("data:image/png;base64,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");
  }

  .no_corner::-webkit-scrollbar-corner {
    box-shadow: none;
    background-image: none !important;
  }

  .go_scrollbar::-webkit-scrollbar-button {
    box-shadow: none;
    width: 16px;
    height: 16px;
    border: 1px solid #b19cd9;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .go_scrollbar::-webkit-scrollbar-button:active {
    background-position: 2px 2px;
  }

  .go_scrollbar::-webkit-scrollbar-button:horizontal:decrement {
    background-image: url("data:image/png;base64,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");
  }

  .go_scrollbar::-webkit-scrollbar-button:horizontal:increment {
    background-image: url("data:image/png;base64,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");
  }

  .go_scrollbar::-webkit-scrollbar-button:vertical:decrement {
    background-image: url("data:image/png;base64,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");
  }

  .go_scrollbar::-webkit-scrollbar-button:vertical:increment {
    background-image: url("data:image/png;base64,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");
  }

  .go_scrollbar::-webkit-scrollbar-button:horizontal:increment:start {
    display: none;
  }

  .go_scrollbar::-webkit-scrollbar-button:horizontal:decrement:end {
    display: none;
  }

  .go_scrollbar::-webkit-scrollbar-button:vertical:increment:start {
    display: none;
  }

  .go_scrollbar::-webkit-scrollbar-button:vertical:decrement:end {
    display: none;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .token_item {
    max-width: 100%;
    max-height: 100%;
  }

  .go_token_box {
    padding: 10px;
    border: 1px dashed #b19cd9;
  }
  .go_token_box:active {
    outline: 1px dotted var(--colorgrad5);
    outline-offset: -6px;
    border: 1px dashed #b19cd9;
  }
  .go_token_image {
    width: 426px;
    max-width: 100%;
    aspect-ratio: 16 / 9;
  }
`;

export default GodObserver;
